import "./App.css";
import React, { useEffect } from "react";
//import Quote from "./components/Quote/quote";
import Contact from "./components/Contact/contact";
import Home from "./components/Home/home";
import AboutUs from "./components/AboutUs/aboutus";
import AOS from "aos";
import "aos/dist/aos.css";
import DesktopNav from "./components/desktop-nav/desktop-nav";
import Process from "./components/Process/Process";
import Pricing from "./components/Pricing/Pricing";
import Work from "./components/Work/Work";
import Services from "./components/Services/Services";
import { RecoilRoot } from "recoil";

function App() {
  /*Process Page Functions Below */

  /*test*/

  /*Process Page Functions Above 

  function handleSmoothScroll() {
    const body = document.body,
      scrollWrap = document.getElementsByClassName("smooth-scroll-wrapper")[0],
      height = scrollWrap.getBoundingClientRect().height - 1,
      speed = 0.04;

    var offset = 0;

    body.style.height = Math.floor(height) + "px";

    function smoothScroll() {
      offset += (window.pageYOffset - offset) * speed;

      var scroll = "translateY(-" + offset + "px) translateZ(0)";
      scrollWrap.style.transform = scroll;

      requestAnimationFrame(smoothScroll);
    }

    smoothScroll();
  }
  */

  /*update price function */

  useEffect(() => {
    AOS.init();
    AOS.refresh();
    /*
    if (document.body.offsetWidth <= 640) {
      const smoothScrollFlag = document.getElementById("smoothScrollID");
      smoothScrollFlag.classList.remove("smooth-scroll-wrapper");
    } else {
      const smoothScrollFlag = document.getElementById("smoothScrollID");
      smoothScrollFlag.classList.add("smooth-scroll-wrapper");
      handleSmoothScroll();
    }
    */

    document.onreadystatechange = () => {
      localStorage.removeItem("name");
      localStorage.removeItem("email");
      localStorage.removeItem("body");
      localStorage.removeItem("budget");
      /*
      if (document.readyState === "complete") {
        var name = localStorage.getItem("name");
        document.getElementById("name").value = name;

        var email = localStorage.getItem("email");
        document.getElementById("email").value = email;

        var body = localStorage.getItem("body");
        document.getElementById("body").value = body;

        var budget = localStorage.getItem("budget");
        document.getElementById("budget").value = budget;
      }
      */
    };

    document.title = `adaptimise - Ottawa Based Web Development & Design Studio`;
    /*

    if (document.body.offsetWidth > 640) {
      const smoothScrollFlag = document.getElementById("smoothScrollID");
      smoothScrollFlag.classList.add("smooth-scroll-wrapper");
      window.addEventListener(
        "resize",
        function () {
          const body = document.body,
            scrollWrap = document.getElementsByClassName(
              "smooth-scroll-wrapper"
            )[0],
            height = scrollWrap.getBoundingClientRect().height - 1;

          body.style.height = Math.floor(height) + "px";
        },
        true
      );
    }
    */

    const ball = document.getElementById("ball");
    const cursor = document.getElementById("cursor");

    let aimX = 0;
    let aimY = 0;

    let cursorX = 0;
    let cursorY = 0;

    let currX = 0;
    let currY = 0;

    let speed = 0.1;

    const animate = function () {
      currX += (aimX - currX) * speed;
      currY += (aimY - currY) * speed;

      ball.style.left = currX + "px";
      ball.style.top = currY + "px";
      cursor.style.left = cursorX + "px";
      cursor.style.top = cursorY + "px";

      requestAnimationFrame(animate);
    };

    animate();

    onmousemove = function (e) {
      aimX = e.pageX;
      aimY = e.pageY;
      cursorX = e.pageX;
      cursorY = e.pageY;

      // ball.style.background = "rgb(255, 255, 255, 0.4)";
    };
  });

  return (
    <div>
      <RecoilRoot>
        <div className="cursors" id="ball"></div>
        <div className="cursor" id="cursor"></div>
        <div id="navbar" className="home-left-navbar">
          <DesktopNav />
        </div>
        <div>
          <div id="home">
            <Home />
          </div>
          <Services />
          <Process />
          <div id="about_us">
            <AboutUs />
          </div>
          <Work />
          <Pricing />

          {/*this is a single radio button 
          <Quote />
          */}
          <Contact />
        </div>
      </RecoilRoot>
    </div>
  );
}

export default App;
